import { render, staticRenderFns } from "./FormControlTypeCurrency.vue?vue&type=template&id=33a73aee&scoped=true"
import script from "./FormControlTypeCurrency.vue?vue&type=script&lang=js"
export * from "./FormControlTypeCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a73aee",
  null
  
)

export default component.exports